import React, { FC, useCallback } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import isSameMonth from 'date-fns/isSameMonth'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { dateToString } from 'lib/helper'

type Props = {
  isActive: boolean
  isClosed: boolean
  isSpecialHoliday: boolean
  currentMonth: Date
  date: Date
}

const ScheduledItemCalendarCell: FC<Props> = React.memo((props) => {
  const { isActive, isClosed, isSpecialHoliday, currentMonth, date } = props

  const dispatch = useDispatch()
  const selectDate = useCallback(
    (date: Date) => {
      dispatch(push(`/scheduled_item/${dateToString(date)}`))
    },
    [dispatch]
  )

  const isThisMonth = isSameMonth(date, currentMonth)

  const className = (() => {
    switch (true) {
      // 選択状態
      case isThisMonth && isActive:
        return styles.table__cell_active
      // 休業日・臨時休業日が祝日
      case isThisMonth && isClosed && isSpecialHoliday:
        return styles.table__cell__holiday_disabled
      // 休業日・臨時休業日
      case isThisMonth && isClosed:
        return styles.table__cell_disabled
      // 当日が祝日
      case isThisMonth && isSameDay(date, new Date()) && isSpecialHoliday:
        return styles.table__cell__holiday_today
      // 当日が祝日
      case isThisMonth && isSameDay(date, new Date()):
        return styles.table__cell_today
      case isThisMonth && isSpecialHoliday:
        return styles.table__cell__holiday
      default:
        return styles.table__cell
    }
  })()

  const onClickDate = () => {
    if (!isThisMonth) {
      return null
    } else {
      selectDate(date)
    }
  }

  return (
    <td className={className} onClick={onClickDate}>
      <span className={styles.table__cell__date}>{isThisMonth ? getDate(date) : ''}</span>
    </td>
  )
})

export default ScheduledItemCalendarCell
